
import { Form , Field, ChildForm } from '../form/form';
import { FormData } from '../form/formData';
import { SelectOption, Vo } from '../form/types';
import { Validators } from '@angular/forms'
import { ServiceAgent} from '../form/serviceAgent';

export class TranscriptSubjectDetailForm extends Form {
	private static _instance = new TranscriptSubjectDetailForm();
	studentId:Field = {
		name:'studentId'
		,controlType: 'Hidden'
		,label: 'studentId'
		,isRequired: true
		,valueType: 1
		,errorId: 'invalidId'
		,maxValue: 9999999999999
	};
	subjectSeasonId:Field = {
		name:'subjectSeasonId'
		,controlType: 'Hidden'
		,label: 'subjectSeasonId'
		,isRequired: true
		,valueType: 1
		,errorId: 'invalidId'
		,maxValue: 9999999999999
	};

	public static getInstance(): TranscriptSubjectDetailForm {
		return TranscriptSubjectDetailForm._instance;
	}

	constructor() {
		super();
		this.fields = new Map();
		this.controls = new Map();
		this.controls.set('studentId', [Validators.required, Validators.max(9999999999999)]);
		this.fields.set('studentId', this.studentId);
		this.controls.set('subjectSeasonId', [Validators.required, Validators.max(9999999999999)]);
		this.fields.set('subjectSeasonId', this.subjectSeasonId);
		this.opsAllowed = {get: true, filter: true};
		this.keyFields = ["studentId", "subjectSeasonId"];
	}

	public getName(): string {
		 return 'transcriptSubjectDetail';
	}
}


export class TranscriptSubjectDetailFd extends FormData {
	constructor(form: TranscriptSubjectDetailForm, sa: ServiceAgent) {
		super(form, sa);
	}

	setFieldValue(name: 'studentId' | 'subjectSeasonId', value: string | number | boolean | null ): void {
		super.setFieldValue(name, value);
	}

	getFieldValue(name: 'studentId' | 'subjectSeasonId' ): string | number | boolean | null {
		return super.getFieldValue(name);
	}
}


export interface TranscriptSubjectDetailVo extends Vo {
	subjectSeasonId?: number, 
	subjectRegisterId?: number, 
	subjectId?: number, 
	slno?: number, 
	studentId?: number, 
	seasonId?: number, 
	credits?: number, 
	grade?: string, 
	gradePoints?: number, 
	instituteId?: number, 
	isPassGrade?: boolean, 
	subjectName?: string, 
	attempts?: number
}
